import { FC } from 'react';
import Chip from '@/components/chip';
import { ChipColor } from './helpers';
import { FormSectionStatus } from '../form/form-section/helpers';

interface Props {
  status: FormSectionStatus;
}

const StatusMap: Record<FormSectionStatus, ChipColor> = {
  preview: 'info',
  new: 'success',
};

const StatusLabelMap: Record<FormSectionStatus, string> = {
  preview: 'Preview',
  new: 'New',
};

const FormStatusChip: FC<Props> = ({ status }) => {
  return <Chip label={StatusLabelMap[status]} size="small" color={StatusMap[status]} />;
};

export default FormStatusChip;
